import * as d3 from "d3";
export interface D3PseudoSelect {
    node: () => HTMLElement | DocumentFragment | null;
    style: (attr: string, value: string | (() => number | string)) => D3PseudoSelect;
    getBoundingClientRect: () => {
        width: number;
    };
}
export const locateTooltip = ({
    d3Tooltip,
    event,
    options: { opacity } = {
        opacity: false
    }
}: {
    d3Tooltip: D3PseudoSelect;
    event: {
        pageX: number;
        pageY: number;
    };
    options?: {
        opacity: boolean;
    };
}) => {
    if (!d3Tooltip) return;

    const left = d3.max([
        40,
        d3.min([
            event.pageX - 50,
            window.innerWidth - (d3Tooltip.node() as HTMLElement).getBoundingClientRect().width - 40
        ])
    ]);

    if (!opacity) {
        return d3Tooltip
            .style("display", "inline-block")
            .style("left", left + "px")
            .style("top", function () {
                var height = d3.select(this).node().getBoundingClientRect().height;
                return event.pageY - height * 1.2 + "px";
            });
    }

    return d3Tooltip
        .style("display", "inline-block")
        .style("left", left + "px")
        .style("opacity", "0.9")
        .style("top", function () {
            var height = d3.select(this).node().getBoundingClientRect().height;
            return event.pageY - height * 1.2 + "px";
        });
};
